import { useLazyQuery } from "@apollo/client/react";import React, { useEffect, useMemo } from 'react';
import './justificarMinutaGrilla.scss';
import { Grid } from '@mui/material';
import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';
import { generateColumnsDefaultConfiguration } from '../../../components/dataGrid/columnHelpers';

import { GET_JUSTIFICAR_MINUTA_CONEXIONES, adaptJustificarMinutaConexionArray } from '../../../data/graphQL/queries/JustificarMinuta/getConexionesEvaluacionMinutaPendiente';

export const JustificarMinutaDetalleItems = ({
  dataRegistro,
  disabledCheckbox,
  itemsEvaluacion,
  setItemsEvaluacion,
  setItemsSeleccionados,
  refetchConexiones,
  setRefetchConexiones
}) => {

  const [rowSelectionModel, setRowSelectionModel] = React.useState([]);

  const [getConexiones, { data: dataConexiones, loading: conexionesLoading }] = useLazyQuery(GET_JUSTIFICAR_MINUTA_CONEXIONES, {
    fetchPolicy: 'no-cache'
  });

	useEffect(() => {
		if (!dataConexiones) return;
    setItemsEvaluacion(adaptJustificarMinutaConexionArray(dataConexiones.conexionesEvaluacionMinutaByIdPendiente));
    setRefetchConexiones(false);
	}, [dataConexiones]);

  useEffect(() => {
    if (!conexionesLoading)
    getConexiones({ variables: { idPendiente: dataRegistro?.idPendiente } });
  }, []);

  useEffect(() => {
    if (refetchConexiones && !conexionesLoading) {
      setItemsEvaluacion([]);
      getConexiones({ variables: { idPendiente: dataRegistro?.idPendiente } });
    }
  }, [refetchConexiones]);

  const handleSelectionModelChange = (ids) => {
    setRowSelectionModel(ids);
    if (ids.length > 0) {
      setItemsSeleccionados(itemsEvaluacion.filter((row, index) => {
        return ids.includes(index + 1);
      }));
    } else {
      setItemsSeleccionados([]);
    }
  };

  const initialColumns = [
  {
    field: 'idConexion',
    headerName: 'Conexión',
    headerAlign: 'left',
    align: 'center',
    flex: 0.15
  },
  {
    field: 'fechaConexion',
    headerName: 'Fecha Conexión',
    headerAlign: 'left',
    align: 'left',
    type: 'date',
    flex: 0.2
  },
  {
    field: 'justificacion',
    headerName: 'Justificación',
    headerAlign: 'left',
    align: 'left',
    flex: 0.30
  }];


  const columns = useMemo(() => generateColumnsDefaultConfiguration(initialColumns), []);

  return (
    <>
            <Grid container spacing={1} sx={{ marginTop: '10px' }}>
                <Grid size={{ xs: 12, md: 12 }}>
                    <div className='section-title'>Items de la Evaluación</div>
                    <DataGridGenerico
            columns={columns}
            rows={itemsEvaluacion}
            toolbar={false}
            maxWidth={columns.reduce(
              (total, column) => total + (column.width || 0),
              0
            )}
            checkboxSelection
            isRowSelectable={(param) => !disabledCheckbox(param.row)}
            onRowSelectionModelChange={handleSelectionModelChange}
            rowSelectionModel={rowSelectionModel}
            loading={conexionesLoading} />
          
                </Grid>
            </Grid>
        </>);

};